import { jsx as _jsx } from "react/jsx-runtime";
import { CountSteps } from './CountSteps';
import { LevvySteps } from './LevvySteps';
import { MakeSteps } from './MakeSteps';
import { MondaySteps } from './MondaySteps';
import { PingSteps } from './PingSteps';
import { ZapierHeader, ZapierSteps } from './ZapierSteps';
export function getIntegrationHeader(slug) {
    switch(slug){
        case 'zapier':
            return /*#__PURE__*/ _jsx(ZapierHeader, {});
        case 'make':
        case 'monday':
        case 'levvy':
        case 'count':
        case 'ping':
            return null;
    }
}
export function getIntegrationSteps(slug) {
    switch(slug){
        case 'make':
            return /*#__PURE__*/ _jsx(MakeSteps, {});
        case 'monday':
            return /*#__PURE__*/ _jsx(MondaySteps, {});
        case 'levvy':
            return /*#__PURE__*/ _jsx(LevvySteps, {});
        case 'count':
            return /*#__PURE__*/ _jsx(CountSteps, {});
        case 'zapier':
            return /*#__PURE__*/ _jsx(ZapierSteps, {});
        case 'ping':
            return /*#__PURE__*/ _jsx(PingSteps, {});
    }
}
